export default __webpack_public_path__ + "static/media/ml.c889dd95.MOV";